import React from 'react';

/**
 * DateCards — three-day strip (prev / current / next) built from the
 * wedding date. Each card shows day number + month short name.
 *
 * Props:
 *   date        — 'YYYY-MM-DD' or ISO string
 *   monthsShort — array of 12 month short names. Default Russian.
 *   activeIndex — which card is "on" (default 1 = center)
 *   classes     — class map: row, card, cardOn, num, mon
 */
const MON_SHORT_RU = ['янв','фев','мар','апр','мая','июн','июл','авг','сен','окт','ноя','дек'];

export function getAdjacentDays(raw, monthsShort = MON_SHORT_RU) {
  if (!raw) return [
    { num: '??', mon: '—' },
    { num: '??', mon: '—' },
    { num: '??', mon: '—' },
  ];
  const wd = new Date(raw);
  return [-1, 0, 1].map(offset => {
    const d = new Date(wd);
    d.setDate(wd.getDate() + offset);
    return { num: String(d.getDate()).padStart(2, '0'), mon: monthsShort[d.getMonth()] };
  });
}

export default function DateCards({
  date,
  monthsShort = MON_SHORT_RU,
  activeIndex = 1,
  classes = {},
}) {
  const days = getAdjacentDays(date, monthsShort);
  const cls = {
    row:    classes.row    || 'date-row',
    card:   classes.card   || 'day-card',
    cardOn: classes.cardOn || 'day-card--on',
    num:    classes.num    || 'day-num',
    mon:    classes.mon    || 'day-mon',
  };
  return (
    <div className={cls.row}>
      {days.map((d, i) => (
        <div key={i} className={`${cls.card}${i === activeIndex ? ' ' + cls.cardOn : ''}`}>
          <span className={cls.num}>{d.num}</span>
          <span className={cls.mon}>{d.mon}</span>
        </div>
      ))}
    </div>
  );
}
